import { ChromePicker } from 'react-color';
import useAddClassPopup from '../hooks/useAddClassPopup.js';
import Button from '../../../../../components/Atoms/Button.jsx';
import '../styles/popup.css';

// Preset color palette for quick selection
const COLOR_PALETTE = [
    '#ef4444', '#f97316', '#f59e0b', '#eab308', '#84cc16', '#22c55e', '#10b981', '#14b8a6',
    '#06b6d4', '#0ea5e9', '#3b82f6', '#6366f1', '#8b5cf6', '#a855f7', '#d946ef', '#ec4899',
    '#f43f5e', '#64748b', '#475569', '#334155', '#1e293b', '#0f172a', '#78716c', '#57534e',
];

const normalizeHex = (c) => (c || '').replace(/^#/, '').toLowerCase();

const AddClassPopup = ({ isModalOpen, classInfo, handleCloseModal, handleSaveClass }) => {
    const {
        className,
        setClassName,
        color,
        aiAliases,
        setAiAliases,
        showColorPicker,
        handleColorClick,
        handleColorChange,
        handleSave
    } = useAddClassPopup({ classInfo, isModalOpen, handleCloseModal, handleSaveClass });

    const colorNorm = normalizeHex(color);
    if (!isModalOpen) return null;

    return (
        <div
            className="modal fade show add-class-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title h4">
                            <i className={`fa ${classInfo ? 'fa-edit' : 'fa-plus'}`}></i>
                            {classInfo ? 'Edit Class' : 'Add New Class'}
                        </h5>
                        <Button type="button" className="close" onClick={handleCloseModal} tooltipText="Close">
                            <span>&times;</span>
                        </Button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <label className="col-form-label">Class name:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={className}
                                    onChange={(e) => setClassName(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label className="col-form-label">
                                    <i className="fa fa-robot" aria-hidden="true"></i> AI detect as <small className="text-muted">(optional)</small>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={aiAliases}
                                    placeholder="e.g. person, man, worker"
                                    onChange={(e) => setAiAliases(e.target.value)}
                                />
                                <small className="form-text text-muted">
                                    Words the AI should look for to fill this class in “My classes only” mode.
                                    Comma-separate synonyms. Leave blank to use the class name itself.
                                </small>
                            </div>
                            <div className="form-group color-palette-group">
                                <label className="col-form-label">Color</label>
                                <div className="color-palette-wrapper">
                                    <div
                                        className="color-palette-current"
                                        style={{ backgroundColor: color }}
                                        onClick={handleColorClick}
                                        title="Click for custom picker"
                                    />
                                    <div className="color-palette-swatches">
                                        {COLOR_PALETTE.map((c) => {
                                            const isSelected = colorNorm === normalizeHex(c);
                                            return (
                                                <button
                                                    key={c}
                                                    type="button"
                                                    className={`color-palette-swatch ${isSelected ? 'color-palette-swatch--selected' : ''}`}
                                                    style={{ backgroundColor: c }}
                                                    onClick={() => handleColorChange({ hex: c })}
                                                    title={c}
                                                >
                                                    {isSelected && <span>✓</span>}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="color-palette-custom-btn"
                                    onClick={handleColorClick}
                                >
                                    {showColorPicker ? 'Hide custom picker' : 'Custom color...'}
                                </button>
                                {showColorPicker && (
                                    <div className="color-div">
                                        <ChromePicker
                                            color={color}
                                            onChange={handleColorChange}
                                            disableAlpha={true}
                                        />
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <Button className="btn btn-secondary" onClick={handleCloseModal} tooltipText="Close">
                            Close
                        </Button>
                        <Button className="btn btn-primary" onClick={handleSave} tooltipText={classInfo ? 'Update' : 'Save'}>
                            {classInfo ? 'Update' : 'Save'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddClassPopup;